// @flow
import React, { Component } from 'react';
import styled from 'styled-components';
import { Link } from '@reach/router';

import notification from 'antd/lib/notification';
import Popconfirm from 'antd/lib/popconfirm';
import AntIcon from 'antd/lib/icon';

import type { Platon } from './../../../lib/types';
import { platonApi } from '../../../lib/api';

import { Icon, ListTable } from './../../../components/ui';
import { notificationLoading } from './../../../components/Notifications';

import { COMMON_MAINTENANCE_COLUMNS } from '../lib';

const StyledIcon = styled(Icon)`
  cursor: pointer;
`;

const StyledAntIcon = styled(AntIcon)`
  cursor: pointer;
  color: #2b7cff;
  margin-right: 10px;
`;

const Operations = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

type Props = {
  vehicleId: number,
  enableDelete: boolean
};

type State = {
  loading: boolean,
  platons: Platon[]
};

class PlatonList extends Component<Props, State> {
  state = {
    loading: false,
    platons: []
  };

  async componentDidMount() {
    this.fetchPlatons();
  }

  fetchPlatons = async () => {
    try {
      this.setState({
        loading: true
      });
      const platons = await platonApi.fetchVehiclePlatons(this.props.vehicleId);
      this.setState({
        platons: platons.data
      });
    } catch (err) {
      notification.error({
        message: 'Ошибка',
        description: err.message
      });
    } finally {
      this.setState({
        loading: false
      });
    }
  };

  onDelete = async (platon: Platon) => {
    try {
      notificationLoading({
        message: 'Удаление...',
        key: 'deleting'
      });
      if (platon.id) {
        await platonApi.deletePlaton(platon.id);
        notification.success({
          message: `Платон успешно удален`
        });
        await this.fetchPlatons();
      }
    } catch (err) {
      notification.error({
        message: 'Ошибка',
        description: err.message
      });
    } finally {
      notification.close('deleting');
    }
  };

  columns = [
    ...COMMON_MAINTENANCE_COLUMNS,
    {
      width: '20px',
      renderRecord: (record: Platon) =>
        record && this.props.enableDelete ? (
          <Operations>
            <Link
              to={`/vehicles/${this.props.vehicleId}/platons/${parseInt(
                record.id
              )}`}
            >
              <StyledAntIcon type="edit" />
            </Link>
            <Popconfirm
              placement="topRight"
              title="Вы действительно хотите удалить?"
              okText="Да"
              cancelText="Нет"
              onConfirm={() => this.onDelete(record)}
            >
              <StyledIcon type="x" />
            </Popconfirm>
          </Operations>
        ) : null
    }
  ];

  render() {
    const { platons, loading } = this.state;
    return (
      <ListTable isLoading={loading} columns={this.columns} data={platons} />
    );
  }
}

export default PlatonList;
